import "@formatjs/intl-relativetimeformat/polyfill";
import "@formatjs/intl-relativetimeformat/locale-data/cs";
import "@formatjs/intl-relativetimeformat/locale-data/en";
import "@formatjs/intl-relativetimeformat/locale-data/pl";
import React from "react";
import {createRoot} from "react-dom/client";
import ReactGA from "react-ga4";
import {App} from "./components/App";
import "./index.css";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<App />);

/* global appConfig */
if (appConfig.googleAnalyticsId != null) {
    ReactGA.initialize(appConfig.googleAnalyticsId);
    ReactGA.send({hitType: "pageview", page: window.location.pathname + window.location.search});
}
